import { Divider, Grid, Paper, Tab, Tabs } from '@material-ui/core';
import React, { useState } from 'react'
import { Title, useAuthenticated } from 'react-admin';
import StudentDashboardActivities from './student-dashboard-activities.component';
import StudentDashboardGrades from './student-dashboard-grades.component';
import StudentDashboardProcesses from './student-dashboard-processes.component';
import { StudentSchedulings } from './student-schedulings.component';
import { TutorialDialog } from '../../tutorial-dialog';

const Panel = (props) => {

    const { children, value, index, ...rest } = props;

    return (
        <div hidden={value !== index} {...rest} >
            {children}
        </div>
    )
}

const StudentDashboard = ({ tutorialComplete, ...props }) => {

    useAuthenticated()

    const [val, setVal] = useState(0)

    const handleTabChange = (event, value) => {
        setVal(value);
    }

    return (
        <Grid container spacing={1} style={{ marginTop: '16px' }}>
            <Paper style={{ width: '100%' }}>
                <Title title={'Dashboard do aluno'} />
                <Grid item xs={12}>
                    <Tabs value={val} onChange={handleTabChange} centered>
                        <Tab label={'Minhas movimentações'} key={'dashboard-activities'} />
                        <Tab label={'Meus agendamentos'} key={'schedulings'} />
                        <Tab label={'Meus atendimentos'} key={'dashboard-processes'} />
                        <Tab label={'Notas'} key={'dashboard-grades'} />
                    </Tabs>
                </Grid>
                <Divider />
                <Panel value={val} index={0}>
                    <StudentDashboardActivities />
                </Panel>
                <Panel value={val} index={1}>
                    <StudentSchedulings />
                </Panel>
                <Panel value={val} index={2}>
                    <StudentDashboardProcesses />
                </Panel>
                <Panel value={val} index={3}>
                    <StudentDashboardGrades />
                </Panel>
            </Paper>
            <TutorialDialog tutorialComplete={tutorialComplete} />
        </Grid >
    )
}

export default StudentDashboard;